import { render, staticRenderFns } from "./StepContent_companyDetails.vue?vue&type=template&id=34f5a223&"
import script from "./StepContent_companyDetails.vue?vue&type=script&lang=js&"
export * from "./StepContent_companyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports